<script>
import axios from 'axios'
const defaultMapCenter = {lat: 47.014006, lng:19.367775}
const defaultMapZoom = 8
export default
{

    computed:
    {
        selectedTracker()
        {
            if (this.selected != null && this.trackers && this.trackers[this.selected])
            {
                return this.trackers[this.selected].id
            }
            return null
        },

        path()
        {
            if (!this.tracker || !this.tracker.data)
                return []
            const path = []
            for (let i = 0; i < this.tracker.data.length; ++i)
            {
                const item = this.tracker.data[i]
                path.push(
                    {
                        lat: item.lat,
                        lng: item.lng
                    }
                )
            }
            return path
        },

        position()
        {
            if (this.lastData)
            {
                return { lat: this.lastData.lat, lng: this.lastData.lng }
            }
            return null
        },

        lastData()
        {
            if (this.tracker && this.tracker.data && this.tracker.data.length > 0)
            {
                return this.tracker.data[0]
            }
            return null
        },

        route()
        {
            if (this.snappedRoute.length > 0)
                return this.snappedRoute
            if (this.rawRoute.length > 0)
                return this.rawRoute
            return []
        }
    },

    watch:
    {
        selected()
        {
            this.fetchTracker(this.selectedTracker).then(() => {
                if (this.tracker && this.tracker.bus_id)
                {
                    this.fetchRoute()
                }
                if (this.position)
                {
                    this.mapCenter = this.position
                    this.mapZoom = 15
                } else {
                    this.mapCenter = defaultMapCenter
                    this.mapZoom = defaultMapZoom
                }
            })
        },
    },

    methods:
    {
        fetchTrackers()
        {
            return axios.get(`${process.env.API_URL}/v1/admin/trackers?nodata`, {}).then(res => {
                this.trackers = res.data
                if (this.trackers.length > 0)
                {
                    this.selected = 0
                }
            })
        },

        fetchTracker(id)
        {
            return axios.get(`${process.env.API_URL}/v1/admin/trackers/${id}`, {}).then(res => {
                this.tracker = res.data
            })
        },

        fetchRoute()
        {
            if (this.tracker && this.tracker.bus_id)
            {
                return axios.get(`${process.env.API_URL}/v1/admin/buses/${this.tracker.bus_id}`).then(res => {
                    this.bus = res.data
                    this.rawRoute = []
                    if (this.bus && this.bus.bus_route && this.bus.bus_route.stations && this.bus.bus_route.stations.length > 0)
                    {
                        const stations = this.bus.bus_route.stations 
                        const route = []
                        for (let i = 0; i < stations.length; ++i)
                        {
                            route.push({
                                lat: stations[i].lat,
                                lng: stations[i].lng,
                            })
                        }
                        this.rawRoute = route
                        this.snapRoute()
                    }
                })
            }
        },

        snapRoute()
        {
            let path = ''
            for(let i = 0; i < this.rawRoute.length; ++i)
            {
                path += `${this.rawRoute[i].lat},${this.rawRoute[i].lng}|`
            }
            if (path.length > 0)
            {
                path = path.substring(0, path.length - 1)
            }
            axios.get(`https://roads.googleapis.com/v1/snapToRoads?path=${path}&interpolate=true&key=${process.env.GOOGLE_MAPS_API_KEY}`, ).then(res => {
                const data = res.data
                if (data && data.snappedPoints)
                {
                    const arr = []
                    for (let i = 0; i < data.snappedPoints.length; ++i)
                    {
                        const item = data.snappedPoints[i]
                        if (item.location && item.location.latitude)
                        {
                            arr.push({
                                lat: item.location.latitude,
                                lng: item.location.longitude,
                            })
                        }
                    }
                    if (arr && arr.length > 0)
                    {
                        this.snappedRoute = arr
                    }
                }

            }).catch(e => {})
        },

    },

    data()
    {
        return {
            trackers: [],
            tracker: {},
            bus: {},
            rawRoute: [],
            snappedRoute: [],
            timer: null,
            selected: null,
            mapCenter: defaultMapCenter,
            mapZoom: defaultMapZoom,
            routeColor: '#52858d',
            pathColor: '#df4d6e',
            mapOptions: {
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                rotateControl: false,
                panControl: false,
                zoomControl: false,
            }
        }
    },

    mounted()
    {
        this.fetchTrackers()
        this.timer = setInterval(() => {
            if (this.selectedTracker)
            {
                this.fetchTracker(this.selectedTracker)
            }
        }, 10000)
    },

    destroyed()
    {
        clearInterval(this.timer)
    }

}
</script>

<template>
<div class="container-fluid">
    <div class="panel panel-primary">
        <div class="panel-heading">
            <div class="row">
                <div class="col-sm-10">
                    <h4>{{ $t('MENU.TRACKERMAP') }}</h4>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <select class="form-control" v-model="selected">
                <option v-for="(tracker, index) in trackers" :key="tracker.id" :value="index">{{ tracker.uid }} - {{ tracker.comment }}</option>
            </select>
            <hr>
            <div v-if="lastData" class="container-fluid" >
                <div class="row" style="background-color: #aad2be;">
                    <div class="col-lg-2">
                        <mv-battery :percent="lastData.batp" :voltage="lastData.batv"></mv-battery>
                    </div>
                    <div class="col-lg-2">
                        <icon name="car"></icon> {{ lastData.speed }} km/h
                    </div>
                    <div class="col-lg-2">
                        <icon name="location-arrow"></icon> {{ lastData.heading }}° 
                    </div>
                    <div class="col-md-2">
                        <icon name="sort"></icon> {{ lastData.alt }}m 
                    </div>
                    <div class="col-md-4">
                        <icon name="map-marker"></icon> {{ lastData.lat }}, {{ lastData.lng }}
                        <icon name="ban" v-if="!lastData.fix" style="color: red;"></icon>
                        <icon name="question-circle" v-else-if="lastData.fix == 1"></icon>
                        <icon name="check" v-else-if="lastData.fix == 2" style="color: blue;"></icon>
                        <icon name="globe" v-else-if="lastData.fix > 2" style="color: darkgreen;"></icon>
                    </div>
                </div>
            </div>
            <gmap-map
                v-if="selected != null"
                :center="mapCenter"
                :zoom="mapZoom"
                :options="mapOptions"
                style="width: 100%; height: 600px;"
            >
                <gmap-polyline v-if="path && path.length > 0" :path="path" :options="{ strokeColor: pathColor }">

                </gmap-polyline>

                <gmap-polyline v-if="route && route.length > 0" :path="route" :options="{ strokeColor: routeColor }">

                </gmap-polyline>
                <gmap-marker v-if="position" :position="position">

                </gmap-marker>
            </gmap-map>
        </div>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/TrackerMap.vue